import { Box } from "@mui/material";
import { BulletChart, Tooltip } from "bizcharts";
import { Region } from "bizcharts/lib/components/Annotation";
import { useEffect, useState } from "react";
import { usePapaParse } from "react-papaparse";
import img from "../../Assets/group-bullet.png";
import DownloadButton from "../Common/DownloadButton";
import ModalTrigger from "../Common/ModalTrigger";

const GroupBulletChart = (props) => {
  const [data, setData] = useState([]);

  const csv = props.csv;
  const { readString } = usePapaParse();

  const handleReadString = () => {
    readString(csv, {
      complete: (results, file) => {
        const sorted = results.data.sort((a, b) => {
          return a["Pesticide"] > b["Pesticide"] ? 1 : -1;
        });
        if (props.part) {
          const half = Math.ceil(results.data.length / 2);
          if (props.part === 1) {
            setData(sorted.slice(0, half));
          } else {
            setData(sorted.slice(half, half + 29));
          }
        } else {
          setData(sorted);
        }
      },
      download: true,
      header: true,
      dynamicTyping: true,
      error: (error, file) => {
        console.log("Error while parsing:", error, file);
      },
    });
  };

  useEffect(() => {
    handleReadString();
  }, []);

  data.map((d) => {
    d["Total number of results"] = [parseInt(d["Total number of results"])];
    d["Total number of theoretical results"] = [
      parseInt(d["Total number of theoretical results"]),
    ];
    d["ranges"] = [
      0,
      parseInt(d["Total number of theoretical results"]) * 1.4 +
        parseInt(d["Total number of theoretical results"]) * 0.3,
    ];
  });

  return (
    <Box>
      <Box display="flex">
        <Box sx={{ width: "100%" }}>
          {!props.second && props.title && (
            <p
              style={{
                fontFamily: "Roboto Condensed, sans-serif",
                marginBottom: "1.1rem",
              }}
            >
              {props.title}
            </p>
          )}
        </Box>
        {!props.first && (
          <Box
            display="flex"
            justifyContent="flex-end"
            alignItems="start"
            sx={{ marginBottom: "0.4rem" }}
          >
            <DownloadButton
              fileName={props.title}
              csv={data}
              imageAsset={img}
            />
          </Box>
        )}
      </Box>
      {data.map((d, idx) => {
        d = [d];
        return (
          <Box key={idx} pb={1}>
            <Box
              sx={{
                width: "100%",
                fontSize: "12px",
                fontFamily: "Roboto Condensed, sans-serif",
                textAlign: "center",
              }}
            >
              {d[0]["Pesticide"]}
            </Box>
            <BulletChart
              autoFit
              data={d}
              height={50}
              range={60}
              measureField="Total number of results"
              targetField="Total number of theoretical results"
              xField=""
              rangeSize={20}
              yAxis={{
                position: "left",
                tickCount: 6,
                max: d[0]["Total number of theoretical results"],

                label: {
                  style: {
                    fontFamily: "Roboto Condensed, sans-serif",
                  },
                },
              }}
              measureSize={10}
              rangeColors={["#ccc"]}
              measureColors={["#608036"]}
              markerColors={["#22294D"]}
              label={false}
              interactions={["active-region"]}
              xAxis={{
                visible: false,
              }}
            >
              <Tooltip shared>
                {(title, items) => {
                  return (
                    <div
                      id="#tooltipWrap"
                      style={{
                        padding: "5px 10px 10px 5px",
                        width: "auto",
                        color: "#22294D",
                        fontFamily: "Roboto Condensed",
                        opacity: "1",
                      }}
                    >
                      <div
                        className="g2-tooltip-title"
                        style={{
                          fontSize: "medium",
                          paddingBottom: "0",
                          fontWeight: "bold",
                        }}
                      >
                        {d[0]["Pesticide"]}
                      </div>
                      <ul className="g2-tooltip-list">
                        <li style={{ padding: "2px 0" }} data-index="0">
                          <span
                            style={{
                              backgroundColor: "#688E31",
                              width: "8px",
                              height: "8px",
                              borderRadius: "50%",
                              display: "inline-block",
                              marginRight: "8px",
                            }}
                          />
                          Total number of results:{" "}
                          {d[0]["Total number of results"].toLocaleString()}
                        </li>
                        <li style={{ padding: "2px 0" }} data-index="1">
                          <span
                            style={{
                              backgroundColor: "#22294D",
                              width: "8px",
                              height: "8px",
                              borderRadius: "50%",
                              display: "inline-block",
                              marginRight: "8px",
                            }}
                          />
                          Total number of theoretical results:{" "}
                          {d[0][
                            "Total number of theoretical results"
                          ].toLocaleString()}
                        </li>
                      </ul>
                    </div>
                  );
                }}
              </Tooltip>
            </BulletChart>
          </Box>
        );
      })}
    </Box>
  );
};

export default GroupBulletChart;
